module.exports = __webpack_public_path__ + "712cc690b9c284e43c3712fa4fbdeef4.svg";